import { withPrefix as gatsbyWithPrefix } from 'gatsby';

export const withPrefix = (src: string, withPrefixFn = gatsbyWithPrefix) => {
  const prefix = `/${process.env.path_prefix}`;
  if (src.startsWith(prefix)) {
    return src;
  }

  return withPrefixFn(src);
};
